import { theme } from '@noths/polaris-client-ribbons-base';
import { PAGE_SLIDER_PAGE_CLASS_NAME } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem, shadowDown } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const container = css`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: var(--neutral-white-base);
`;

export const appPanel = css`
  margin: 0 ${spacing.md}px;
  border-top: 1px solid var(--neutral-black-30);
  border-bottom: 1px solid var(--neutral-black-30);
`;

export const localePanel = css`
  padding: ${spacing.md}px;
`;

// Anti-aliasing issue solution: https://stackoverflow.com/a/39163461
const fixBackgroundExposureBug = css`
  border: 2px solid transparent;
  background-clip: padding-box;
`;

export const closeBtn = css`
  position: absolute;
  z-index: 2;
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  right: 0;
  top: ${pxToRem(spacing.md)};
  display: flex;
  align-items: center;
  outline: 0 none;
  background-color: var(--neutral-white-base);
  border: 2px solid transparent;
  background-clip: padding-box;
  ${fixBackgroundExposureBug}
`;

const TRANSITION_EASE_IN = 'cubic-bezier(1, 0.2, 0.8, 0.6)';

const TRANSITION_DURATION = '500ms';

export const headerPageSliderTransition = `transform ${TRANSITION_DURATION}`;

export const contentPageSliderTransition = `transform ${TRANSITION_DURATION} 100ms`;

export const headerPageSliderWrapper = css`
  ${shadowDown}
  position:relative;
  z-index: 1;

  .${PAGE_SLIDER_PAGE_CLASS_NAME} {
    transition: opacity ${TRANSITION_DURATION} ${TRANSITION_EASE_IN};
    opacity: 1;

    &[aria-hidden='true'] {
      opacity: 0;
    }
  }
`;
